import "./assets/scss/style.scss";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import { PrimeReactProvider } from "primereact/api";
import MainNavigation from "./components/navigation/MainNavigation";
import { NavProvider } from "./context/NavContext";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { ProfileProvider } from "./context/ProfileContext";
import { ConfigProvider } from "antd";
import { antdTheme, themeMui } from "./components/styled/Theme";
import { ThemeProvider } from "@mui/material";
import { GlobalProvider } from "./context/GlobalContext";
import "aos/dist/aos.css";
import AOS from "aos";

import { useEffect } from "react";
import Modals from "./components/layouts/Modals";
import { ContextAwareConfirmation } from "react-confirm";

const App = () => {
  // useEffect(() => {
  //   Aos.init();
  //   Aos.refresh();
  // }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();

    // const handleContextMenu = (e) => e.preventDefault();
    // document.addEventListener("contextmenu", handleContextMenu);

    // const handleKeyDown = (e) => {
    //   if (
    //     e.key === "F12" ||
    //     (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key))
    //   ) {
    //     e.preventDefault();
    //     // alert("🚫 DevTools disabled");
    //   }
    // };
    // document.addEventListener("keydown", handleKeyDown);

    // return () => {
    //   document.removeEventListener("contextmenu", handleContextMenu);
    //   document.removeEventListener("keydown", handleKeyDown);
    // };
  }, []);

  return (
    <ThemeProvider theme={themeMui}>
      <ConfigProvider theme={antdTheme}>
        <PrimeReactProvider>
          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            toastOptions={{
              duration: 4000,
              success: {
                style: {
                  background: "green",
                  color: "white",
                  fontSize: 14,
                },
              },
              error: {
                style: {
                  background: "red",
                  color: "white",
                  fontSize: 14,
                },
              },
            }}
          />
          <GlobalProvider>
            <BrowserRouter>
              <AuthProvider>
                <ProfileProvider>
                  <NavProvider>
                    <>
                      <ContextAwareConfirmation.ConfirmationRoot />
                      <Modals />
                      <MainNavigation />
                    </>
                  </NavProvider>
                </ProfileProvider>
              </AuthProvider>
            </BrowserRouter>
          </GlobalProvider>
        </PrimeReactProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default App;
